import _defineProperty from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ConsoleLogger } from '../Logger/ConsoleLogger.mjs';
import { NO_HUBCALLBACK_PROVIDED_EXCEPTION } from '../constants.mjs';
import { AmplifyError } from '../errors/AmplifyError.mjs';
import '../types/errors.mjs';
import '../errors/errorHelpers.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' ? Symbol('amplify_default') : '@@amplify_default';
var logger = new ConsoleLogger('Hub');

var HubClass = /*#__PURE__*/function () {
  function HubClass(name) {
    _classCallCheck(this, HubClass);

    this.listeners = new Map();
    this.protectedChannels = ['core', 'auth', 'api', 'analytics', 'interactions', 'pubsub', 'storage', 'ui', 'xr'];
    this.name = name;
  }
  /**
   * Used internally to remove a Hub listener.
   *
   * @remarks
   * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
   */


  _createClass(HubClass, [{
    key: "_remove",
    value: function _remove(channel, listener) {
      var holder = this.listeners.get(channel);

      if (!holder) {
        logger.warn("No listeners for ".concat(channel));
        return;
      }

      this.listeners.set(channel, _toConsumableArray(holder.filter(function (_ref) {
        var callback = _ref.callback;
        return callback !== listener;
      })));
    }
  }, {
    key: "dispatch",
    value: function dispatch(channel, payload, source, ampSymbol) {
      if (typeof channel === 'string' && this.protectedChannels.indexOf(channel) > -1) {
        var hasAccess = ampSymbol === AMPLIFY_SYMBOL;

        if (!hasAccess) {
          logger.warn("WARNING: ".concat(channel, " is protected and dispatching on it can have unintended consequences"));
        }
      }

      var capsule = {
        channel: channel,
        payload: _objectSpread({}, payload),
        source: source,
        patternInfo: []
      };

      try {
        this._toListeners(capsule);
      } catch (e) {
        logger.error(e);
      }
    }
  }, {
    key: "listen",
    value: function listen(channel, callback) {
      var _this = this;

      var listenerName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'noname';
      var cb;

      if (typeof callback !== 'function') {
        throw new AmplifyError({
          name: NO_HUBCALLBACK_PROVIDED_EXCEPTION,
          message: 'No callback supplied to Hub'
        });
      } else {
        // Needs to be casted as a more generic type
        cb = callback;
      }

      var holder = this.listeners.get(channel);

      if (!holder) {
        holder = [];
        this.listeners.set(channel, holder);
      }

      holder.push({
        name: listenerName,
        callback: cb
      });
      return function () {
        _this._remove(channel, cb);
      };
    }
  }, {
    key: "_toListeners",
    value: function _toListeners(capsule) {
      var channel = capsule.channel,
          payload = capsule.payload;
      var holder = this.listeners.get(channel);

      if (holder) {
        holder.forEach(function (listener) {
          logger.debug("Dispatching to ".concat(channel, " with "), payload);

          try {
            listener.callback(capsule);
          } catch (e) {
            logger.error(e);
          }
        });
      }
    }
  }]);

  return HubClass;
}();
/* We export a __default__ instance of HubClass to use it as a
pseudo Singleton for the main messaging bus, however you can still create
your own instance of HubClass() for a separate "private bus" of events. */


var Hub = new HubClass('__default__');
/**
 * @internal
 *
 * Internal hub used for core Amplify functionality. Not intended for use outside of Amplify.
 *
 */

var HubInternal = new HubClass('internal-hub');
export { AMPLIFY_SYMBOL, Hub, HubClass, HubInternal };